import "./FacilityUserViewComponent.scss";
import React, {useEffect, useState} from "react";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import {Edit} from "@mui/icons-material";
import {CommonService} from "../../../../../shared/services";
import TableWrapperV2Component
    from "../../../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {APIConfig} from "../../../../../constants";
import {ITableColumn} from "../../../../../shared/models/table.model";
import commonService from "../../../../../shared/services/common.service";
import ChipComponent from "../../../../../shared/components/chip/ChipComponent";
import TooltipComponent from "../../../../../shared/components/tooltip/tooltipComponent";

interface FacilityUserViewComponentProps {
    userList?: any;
    facilityId: number | string;
    onEditModeOpen?: Function;
    onUpdateComplete: Function;
    canEdit: boolean;
}

const MODULE_NAME = "facilityUserList";
const FacilityUserViewComponent = (props: FacilityUserViewComponentProps) => {
    const {userList, onEditModeOpen, canEdit, facilityId} = props;

    const [userDetailsList, setUserDetailsList] = useState<any[]>([]);
    const columns: ITableColumn[] = [
        {
            id: 'id',
            label: 'ID',
            isDefaultColumn: true,
            fixed: 'left',
            width: '150',
            content: (item: any) => (
                <>
                    {item?.userDetails?.id || '-'}
                </>
            )
        },
        {
            id: 'userName',
            label: 'User Name',
            isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {commonService.generateNameFromNameObject(item?.userDetails) || '-'}
                </>
            )
        },
        {
            id: 'gender',
            label: 'Gender',
            isDefaultColumn: false,
            align: 'center',
            content: (item: any) => (
                <>
                    {item?.userDetails?.gender || '-'}
                </>
            )

        },
        {
            id: 'mobileNumber', label: 'Mobile Number', isDefaultColumn: true, align: 'center',
            content: (item: any) => (
                item?.userDetails?.mobileNumber ?
                    <>
                        {CommonService.getMaskedMobileNumber(item?.userDetails?.mobileNumber)}
                    </> : <>-</>
            )
        },
        {
            id: 'emailId',
            label: 'Email ID',
            isDefaultColumn: true,
            align: 'left',
            width: '250',
            content: (item: any) => (
                <>
                    {item?.userDetails?.emailId || '-'}
                </>
            )
        },
        {
            id: 'role',
            label: 'Role',
            isDefaultColumn: true,
            width: '150',
            content: (item: any) => (
                <>
                    {item?.userDetails?.roleObj?.title || '-'}
                </>
            )
        },
        {
            id: 'location',
            label: 'Assigned Location',
            isDefaultColumn: true,
            width: '150',
            content: (item: any) => {
                const locationLists = item?.locationDetails?.map((location: any) => location.name) || [];

                const chips = locationLists.map((locationName: string) => (
                    <ChipComponent key={locationName} label={locationName}/>
                ));

                return (
                    <>
                        {locationLists.length > 0 ? <TooltipComponent arrow={true} placement={"top"} tooltip={chips}>
                            <div
                                className={"ellipses-text"}>{locationLists.map((locationName: string) => locationName).join(",")}</div>
                        </TooltipComponent> : "-"}
                    </>
                );
            }
        }
    ];

    useEffect(() => {
        if (userList?.length > 0) {
            setUserDetailsList(userList)
        }
    }, [userList]);

    return (
        <div className={'facility-user-view-component assigned-user-view-tab'}>
            {!userDetailsList?.length ?
                <div className={'no-assigned-user-wrapper'}>
                    <div className='no-assigned-user-header'>
                        No User have been added to this facility.
                    </div>
                    <div className={'no-assigned-user-button'}>
                        {canEdit &&
                            <ButtonComponent
                                variant={"outlined"}
                                // className={'width-50'}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Assign User
                            </ButtonComponent>
                        }
                    </div>
                </div> :
                <div
                    className={'d-flex justify-content-space-between align-items-center mrg-bottom-10'}>
                    <div className="form-sub-title mrg-top-15">Added Providers</div>
                    {
                        canEdit &&
                        <ButtonComponent
                            variant={"outlined"}
                            fullWidth={false}
                            type={'button'}
                            color={"primary"}
                            handleClick={onEditModeOpen}
                            startIcon={<Edit/>}
                        >
                            Edit Details
                        </ButtonComponent>
                    }
                </div>
            }
            {/*{userDetailsList?.map((user: any, index: any) => {*/}
            {/*    return (*/}
            {/*        <div key={index} className="accordion-layout mrg-bottom-20">*/}
            {/*            <AccordionComponent*/}
            {/*                isExpanded={userList[index]?.isFacilityUserExpand}*/}
            {/*                title={`${CommonService.capitalizeFirstLetter(user.firstName)} ${CommonService.capitalizeFirstLetter(user.middleName)} ${CommonService.capitalizeFirstLetter(user.lastName)}`}*/}
            {/*                subTitle={`(User ID: ${user?.id} | ${userList[index]?.roleObj?.title || ""})`}*/}
            {/*            >*/}
            {/*                <UserDetailsComponent user={user}/>*/}
            {/*            </AccordionComponent>*/}
            {/*        </div>*/}
            {/*    )*/}
            {/*})*/}
            {/*}*/}
            {
                userDetailsList?.length > 0 && <div className="table-list-container">
                    <TableWrapperV2Component
                        isPaginated={false}
                        isColumnFilterVisible={false}
                        columns={columns}
                        url={APIConfig.GET_FACILITY_ASSIGNED_USER_LIST.URL(facilityId)}
                        method={APIConfig.GET_FACILITY_ASSIGNED_USER_LIST.METHOD}
                        // extraPayload={{}}
                        moduleName={MODULE_NAME}
                    />
                </div>
            }
        </div>
    );

};

export default FacilityUserViewComponent;
